import React from 'react';

export default class Select extends React.Component {
    static defaultProps = {
        options: [],
        label: '',
    }

    render() {
        const {value, options, onChange, name, label, ...props} = this.props;

        return (
            <div className="Select">
                <label
                    htmlFor={name}
                    className="Select__Label"
                >
                    {label}
                </label>
                <select
                    className="Select__Input"
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    {...props}
                >
                    {options.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>
        );
    }
}
